import { render } from "./SeguradosView.vue?vue&type=template&id=884db140"
import script from "./SeguradosView.vue?vue&type=script&lang=js"
export * from "./SeguradosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__